<template>
<main class="container-1-1">

    <div class="container-header">
        <Breadcrumb
        v-bind:links="routesBread"
        >
        </Breadcrumb>
        <!-- <h2>Historial de cambios</h2> -->
        <TabNav :links="routesNav" />
    </div>
    
    <div class="container-body">
        <LogItem
        v-bind:logs="logs"
        v-bind:showInfo="true"
        v-bind:fullMode="true"
        v-bind:showControls="true"
        @itemSelected="responseSelectedItem"
        @queryChanged="onQueryChanged">
        </LogItem>

        <Pagination
        v-show="totalPages!=0"
        v-bind:totalPages="totalPages"
        v-bind:currentPage="currentPage"
        v-bind:pageSize="pageSize"
        v-on:pagechanged="pageChangedClick"
        >
        </Pagination>
    </div>

    <div class="container-list">
      <div class="log-detail-panel">
        <strong>Recurso del registro seleccionado</strong>
        <div v-if="selectedItem" >
            <button class="btn btn-secondary" v-clipboard:copy="JSON.stringify(selectedItem)" v-clipboard:success="onCopyJson" v-clipboard:error="onCopyJsonError">
                <font-awesome-icon icon="copy"></font-awesome-icon>
                Copiar JSON
            </button>  
        </div>
        <p v-else class="log-detail-panel__empty">{{ selectionMade ? 'Este registro no tiene un recurso asociado' : 'Selecciona un registro de la tabla para ver el recurso asociado' }}</p>
        <json-view 
        v-if="selectedItem"
        :data="selectedItem"
        rootKey="Categoría"
        :maxDepth="3"
        />
      </div>
    </div>

</main>
</template>

<script>
// @ is an alias to /src
import SideNav from '@/components/SideNav.vue'
import Breadcrumb from '@/components/Breadcrumb.vue'
import TabNav from '@/components/TabNav.vue'
import Pagination from '@/components/Pagination.vue'
import LogItem from '@/components/LogItem.vue'
import { JSONView } from "vue-json-component";

import {formatter} from '@/components/mixin/formatter.js'
import {pagination} from '@/components/mixin/pagination.js'
import {restCategory} from '@/components/mixin/restCategory.js'

export default{
    name: 'test',
    mixins: [formatter, pagination, restCategory],
    data(){
        return{
            message: '',
            logs: [],
            query: { order: 'desc', operationType: '', search: '' },
            selectedItem: null,
            selectionMade: false
        }
    },
    components:{
        SideNav,
        Breadcrumb,
        Pagination,
        LogItem,
        "json-view": JSONView,
        TabNav
    },
    computed: {
        routesBread: function(){
          return [
                {name: 'Capas', path: '/capas'},
                {name: 'Categorías', path: '/capas/categorias-de-capas/'},
                {name: this.category.name, path: '/capas/categorias-de-capas/' + this.$route.params.idCategory},
                {name: 'Historial de cambios'}
          ]
        },
    },
    props: [],
    methods:{
        pageChangedClick: function (page){
            this.currentPage = page;
            this.getLogs(this.currentPage);
        },
        getLogs: function(page) {
            const that = this;
            this.$http.get(this.$store.getters.backendurl + 'api/v1/logs/categories/' + this.$route.params.idCategory + this.buildLogParams(page))
            .then(function (response) {
                that.logs = response.data
                response.headers.totalpages == undefined ? that.totalPages = 0 : that.totalPages = parseInt(response.headers.totalpages, 10);
            })
            .catch(function (error) {
                console.log(error)
                that.message = error.response.data.message;
            });
        },
        onCopyJson: function() {
            this.$store.dispatch('toast/show', { message: 'JSON copiado', type: 'info' });
        },
        onCopyJsonError: function() {
            this.$store.dispatch('toast/show', { message: 'No se pudo copiar', type: 'error' });
        },
        responseSelectedItem: function(item) {
            this.selectionMade = true;
            this.selectedItem = this.parseLogSnapshot(item);
        },
        onQueryChanged: function (query) {
            this.query = query;
            this.currentPage = 1;
            this.getLogs(this.currentPage);
        },
        buildLogParams: function (page) {
            let params = '?page=' + page + '&order=' + this.query.order;
            if (this.query.operationType) {
                params += '&operation_type=' + encodeURIComponent(this.query.operationType);
            }
            if (this.query.search) {
                params += '&search=' + encodeURIComponent(this.query.search);
            }
            return params;
        }
    },
    updated () {

    },
    created () {
        //Verificar permisos
        this.$store.getters.getPermissions.layers? true:this.$router.push('/pagina-no-encontrada')
    },
    beforeMount() {
        
    },
    mounted () {
        this.getCategory();
        this.getLogs(this.currentPage);
    }
}
</script>

<style lang="scss">

#json-view{
    .properties{
        display: none;
    }
}

</style>
